import { useCookie, useRuntimeConfig } from '#app';
import { reactive } from 'vue';
import { isLoggedInCustomer, type ICartData } from '@/types/cart';
import { useStorage } from '@vueuse/core';

const cartState = reactive<ICartData>({
  customer: undefined,
  cart: undefined,
});

const cartStoreId = 'wmf-shop'; /*Tbd name by brand*/
const cartStore = useStorage(cartStoreId, cartState);

export function useShoppingCart() {
  const config = useRuntimeConfig();

  const length = () => {
    return cartStore.value.cart?.summary_count ?? 0;
  };

  function sync() {
    /* Sync routine */
    const COOKIE_KEY = cartStoreId;

    if (config.public.IS_STAGING === false) {
      /**
       * This fix is necessary since Magento always sets the cookie to the current path.
       * After login, this path is "/customer/account/login/" and the cookie is not able to be read by any website that is not on this path (e.g. "/").
       */
      // HACK: This is a hot fix and should be removed once the cookie is always set to path "/" by Y1.
      document.cookie.split(';').forEach(cookie => {
        const cookieSplit = cookie.split('=');
        const name = cookieSplit[0].trim();
        const value = cookieSplit[1]?.trim();
        if (name === COOKIE_KEY) {
          try {
            const parsed = JSON.parse(decodeURIComponent(value)) as ICartData;
            if (isLoggedInCustomer(parsed.customer)) {
              document.cookie = `${COOKIE_KEY}=${value};Secure;Domain=.wmf-coffeemachines.com;SameSite=Lax;path=/`;
            }
          } catch (e) {
            console.error('Failed to hot-fix "wmf-shop" cookie:');
            console.error(e);
          }
        }
      });
    }

    /* Read cookie */
    const storeCookie = useCookie(COOKIE_KEY);
    let defaultCartItem: ICartData = {};

    if (storeCookie.value) {
      try {
        defaultCartItem = storeCookie.value as ICartData;
      } catch (error) {
        console.error('Error parsing cookie value', error);
      }
    }

    cartStore.value = defaultCartItem;
  }

  return {
    length,
    sync,
    cartStore,
  };
}
